module.exports = __webpack_public_path__ + "static/media/bookmark-outlined.0b2499cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bookmark-outlined.svg
// module id = 863
// module chunks = 0